import { render, staticRenderFns } from "./SgAddressComponent.vue?vue&type=template&id=060bbc3b"
import script from "./SgAddressComponent.vue?vue&type=script&lang=js"
export * from "./SgAddressComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../HCP/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports